// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"411":"a7b64a5e5890ea24","3877":"fe336940f98fdfab","4656":"f87eca749d39bf98","7666":"75a2926e634841be","8989":"73e41c718866c58e"}[chunkId] + ".css";
};